import { store } from 'redux/store';
import { PermissionTypes } from 'helper/products';
import { selectProductKeys } from 'redux/reducers/productsReducer';
import { sendInterfaceErrorToSentry } from 'helper/sendErrorToSentry';
import { MISSING_KEY_PREFIX } from 'helper/requests/productKeyUrl';

/**
 * Chave do produto para compor a URL dos endpoints.
 *
 * Lê do store (o PersistGate garante o rehydrate antes do primeiro render, o
 * que elimina a corrida com o throttle do redux-persist que existia na leitura
 * direta do localStorage). Sem chave, devolve a sentinela `__missing__<produto>`
 * — o baseQuery a intercepta ANTES do envio e obtém a chave no servidor
 * (recuperação silenciosa, issue #1841), em vez de enviar a request sem chave
 * e virar 403 silencioso.
 */
export default function getProductKey(product: string) {
  try {
    const key = selectProductKeys(store.getState())[product as PermissionTypes];
    return key || `${MISSING_KEY_PREFIX}${product}`;
  } catch (e) {
    sendInterfaceErrorToSentry('MISSING PRODUCT KEY', `No product key for "${product}"`, e);
    return `${MISSING_KEY_PREFIX}${product}`;
  }
}
